import styled from "styled-components";

const StyledVendorFilter = styled.div`
  width: 100%;

`;

export default StyledVendorFilter;
